<template>
	<div class="modal order-modal">
    <div class="overlay" @click="$parent.closeOrderModal"></div>
    <div class="wrapper">
      <div class="container">
        <img src="./../image/close.svg" @click="$parent.closeOrderModal" class="close"/>
        <div class="title small">{{$t("Payment Method")}}</div>
        <div class="button-list-container">
          <div class="button-list" v-if="paymentMethods && paymentMethods.length">
            <button v-for="(item, i) in paymentMethods" class="img-btn" @click="submit(item.code)" :key="i">
              <img :src="$parent.appDomain + item.image" class="img"/>
              {{ item.title }}
            </button>
          </div>
          <transition name="fade">
            <div class="desc red" v-if="$parent.error">{{ $t($parent.error) }}</div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapGetters} from "vuex";

export default {
	name: 'OrderModal',
	props: ['orderData'],
	data: function() {
		return {

		}
	},
	methods: {
		submit(type) {
      this.$emit('orderSubmit', this.orderData, type)
    },
	},
	mounted() {
  },
  computed: {
    ...mapGetters('app', ['currency']),
    paymentMethods () {
      if (this.$parent.paymentMethods && this.currency && this.currency in this.$parent.paymentMethods) {
        return this.$parent.paymentMethods[this.currency];
      }

      return this.$parent.paymentMethods;
    }
  }
}
</script>
